import React from "react";
import { Container, Kpis } from "./styles";
import KpiCard from "./components/KpiCard";

const Component = ({ data, ...rest }) => {
  return (
    <Container>
      <Kpis>
        {data.map((kpi) => (
          <KpiCard data={kpi} key={`kpi-${kpi.id}`} {...rest} />
        ))}
      </Kpis>
    </Container>
  );
};

export default Component;
